import * as React from 'react';
import { FormattedMessage  } from 'react-intl';
import './search.scss';

class Search extends React.Component  {

  render() {

    return (
      <div id="app-search">
        <div className="container">
          
        </div>
      </div>
    );
  }
}

export default Search;
